import Webcam from "react-webcam";
import { useRef, useCallback, useState, useEffect } from "react";
import uploadFile from "../../../services/uploadFile";
import IconBtn from "../icon-btn";
import { DeleteIcon } from "../../svg";

function WebcamCapture({
  multiPhoto = false,
  noOfMultiPhoto = 1,
  defaultImages,
  handleWebCapture
}: any) {
  const webcamRef = useRef<Webcam>(null);
  const [localImages, setLocalImages] = useState<string[]>(defaultImages);
  const [capturedImages, setCapturedImages] = useState<string[]>(defaultImages);
  const [isCaptureStarted, setIsCaptureStarted] = useState<boolean>(false);
  const [isCaptureCompleted, setIsCaptureCompleted] = useState<boolean>(false);
  const [resolution, setResolution] = useState<{width: number;height: number;} | null>(null);

  const dataURLtoFile = (dataUrl: string, filename: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
    const bstr = atob(arr[1]);
    const u8arr = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; i++) u8arr[i] = bstr.charCodeAt(i);
    return new File([u8arr], filename, { type: mime });
  };

  const uploadCapturedImage = async (base64Image: string) => {
    try {
      const randomSuffix = Math.random().toString(36).substring(2, 8);
      const filename = `${randomSuffix}-webcam.jpg`;
      const file = dataURLtoFile(base64Image, filename);
      const extension = "jpg";
      const { response } = await uploadFile(file, extension);
      const url = response.data.fileUrl;

      setCapturedImages((prev: string[]) => [...prev, url]);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

const handleSubmitWebCapture = useCallback(() => {
  if (!resolution || !resolution.width || !resolution.height) {
    return;
  }
    let imageSrc = webcamRef.current?.getScreenshot({ width: resolution.width,height: resolution.height });
  
  if (!imageSrc || localImages.length >= noOfMultiPhoto) return;

  setIsCaptureStarted(true);
  uploadCapturedImage(imageSrc);

  setLocalImages((prev) => [...prev, imageSrc as string]);
}, [resolution, localImages, noOfMultiPhoto]);

  useEffect(() => {

    if (isCaptureStarted && noOfMultiPhoto == capturedImages.length) {
      setIsCaptureCompleted(true);
      setIsCaptureStarted(false);
      handleWebCapture(1, capturedImages)
    }

  }, [isCaptureStarted, capturedImages, noOfMultiPhoto])


  const removeImage = (index: number) => {
    setLocalImages((prev) => prev.filter((_, i) => i !== index));
    setCapturedImages((prev: string[]) => prev.filter((_, i) => i !== index));
  };

  const reset = () => {
    setLocalImages([]);
    setCapturedImages([]);    
    setIsCaptureStarted(false);
    setIsCaptureCompleted(false);
    handleWebCapture(2, []);
  };


  useEffect(() => {
    async function getResolution() {
      try {
        const constraints = {
          video: {
            width: { ideal: 1280 }, 
            height: { ideal: 720 },
            facingMode: "user",
          },
          audio: false,
        };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);

        const videoTrack = stream.getVideoTracks()[0];

        const settings = videoTrack.getSettings();

        setResolution({
          width: settings.width || 0,
          height: settings.height || 0,
        });

        videoTrack.stop();
      } catch (error) {
        console.error("Could not get camera resolution", error);
      }
    }

    getResolution();
  }, []);

  return (
    <div className="w-full flex flex-col items-center gap-4 mt-2">
      <div className="w-full rounded-lg overflow-hidden shadow relative">
        {capturedImages.length != noOfMultiPhoto && !isCaptureCompleted ? (
          <Webcam
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            audio={false}
            mirrored={true}
            videoConstraints={{
              facingMode: "user",
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            }}
            style={{
              width: "100%",
              height: "auto", 
              objectFit: "cover"
            }}
            className="w-full h-[300px] object-cover"
          />
        ) : (
          <div>
            <div>
              <div className="grid grid-cols-2 gap-4 justify-center mt-4 p-4">
                {localImages.map((img, index) => (
                  <div key={index} className="relative w-[100px] h-[100px] rounded overflow-hidden border shadow">
                    <img src={img} alt={`Captured ${index}`} className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              {
                !isCaptureStarted && isCaptureCompleted &&
                <div className="text-center text-green-600 font-bold py-4 text-[1.2rem]"> All photos captured for Registeration!</div>
              }
              <div className="w-full h-auto flex justify-center mt-4">
                <button onClick={reset} className="px-4 py-1 mb-[2%] text-[1.2rem] bg-gray-500 text-white rounded">Reset All</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex gap-4">
        {!isCaptureCompleted && capturedImages.length != noOfMultiPhoto && (
          <div>
            <button onClick={handleSubmitWebCapture} className="px-4 py-1 bg-blue-600 text-white rounded text-[1.2rem] mb-[10%]">
              {multiPhoto === false
                ? "Capture"
                : `Capture (${capturedImages.length}/${noOfMultiPhoto})`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default WebcamCapture;
